// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__tkNS0","inner":"DefaultLayout_inner__cAwRx","content":"DefaultLayout_content__e9Pwb","go-top-btn":"DefaultLayout_go-top-btn__i0yGh"};